import { useLocation } from 'react-router-dom'
import { CheckIcon } from '@heroicons/react/solid'

const Stepper = () => {
  const location = useLocation()
  const currentPath = location.pathname

  const steps = [
    { id: 'enter-amount', label: 'Amount' },
    { id: 'select-method', label: 'Payment' },
    { id: 'cash-in', label: 'Confirm' },
  ]

  const getCurrentStepIndex = () => {
    for (let i = 0; i < steps.length; i++) {
      if (currentPath.includes(steps[i].id)) {
        return i
      }
    }
    return -1
  }

  const getStepStatus = (stepIndex: number) => {
    const currentIndex = getCurrentStepIndex()

    if (currentIndex === -1) return 'upcoming'
    if (stepIndex < currentIndex) return 'completed'
    if (stepIndex === currentIndex) return 'current'
    return 'upcoming'
  }

  const displayStepper = () => {
    return location.pathname.includes('topup')
  }

  if (!displayStepper()) return null

  return (
    <div className="mt-8 mb-4">
      <div className="flex items-center justify-center">
        {steps.map((step, index) => {
          const status = getStepStatus(index)
          return (
            <div key={step.id} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all ${
                    status === 'completed'
                      ? 'bg-primary-500 text-white'
                      : status === 'current'
                      ? 'bg-primary-500 text-white ring-4 ring-primary-100'
                      : 'bg-neutral-200 text-neutral-500'
                  }`}
                >
                  {status === 'completed' ? (
                    <CheckIcon className="w-5 h-5" />
                  ) : (
                    index + 1
                  )}
                </div>
                <span
                  className={`mt-2 text-xs font-medium ${
                    status === 'upcoming'
                      ? 'text-neutral-400'
                      : 'text-neutral-700'
                  }`}
                >
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`w-16 sm:w-24 h-1 mx-2 rounded-full transition-all ${
                    getStepStatus(index + 1) !== 'upcoming'
                      ? 'bg-primary-500'
                      : 'bg-neutral-200'
                  }`}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Stepper
